import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Layout } from "../components/Layout";
import { BiniBubble } from "../components/Bini";
import { t } from "../i18n";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState(params.get("token") ? "idle" : "invalid");
  const go = async () => {
    try { await api.post("/newsletter/unsubscribe", { token: params.get("token") || "" }); setState("done"); }
    catch { setState("invalid"); }
  };
  return (
    <Layout back="/">
      <div className="cloud-card puffs mx-auto mt-10 max-w-xl p-8" data-testid="unsubscribe-page">
        <h1 className="text-3xl font-extrabold">{t("newsletter.unsubTitle")}</h1>
        {state === "idle" && (
          <button type="button" onClick={go} data-testid="unsubscribe-btn" className="btn-3d mt-6 w-full" style={{ "--c": "#F0303A" }}>{t("newsletter.unsubDo")}</button>
        )}
        {state === "done" && <BiniBubble className="mt-6" testId="unsubscribe-done">{t("newsletter.unsubDone")}</BiniBubble>}
        {state === "invalid" && <BiniBubble className="mt-6" testId="unsubscribe-invalid">{t("newsletter.unsubInvalid")}</BiniBubble>}
      </div>
    </Layout>
  );
}
